module.exports = __webpack_public_path__ + "img/removeIcon.fcae3b6c.svg";